// @flow

import { useState, useEffect, useRef } from 'react';
import { isEqual } from 'lodash';

import { subscribe, authGet } from '../utils/authentication';

const useAuth = (): Object => {
  const [auth, setAuth] = useState(authGet().toJS());
  const authRef = useRef(auth);

  useEffect(() => {
    const subscriber = (newAuth) => {
      const newAuthObj = newAuth ? newAuth.toJS() : {};

      if (isEqual(authRef.current, newAuthObj)) {
        return;
      }

      authRef.current = newAuthObj;
      setTimeout(() => setAuth(newAuthObj), 1); // defer to avoid redux hook issue
    };

    const unsubscribe = subscribe(subscriber);
    return unsubscribe;
  }, []);

  return auth;
};

export default useAuth;
